<template>
    <div>
        <form-row>
            <form-cell>
                <radio-field
                    :label="$t('forms.auth.register.fields.practice_type.label')"
                    :hasAutofocus="true"
                    :isRequired="true"
                    :formData="formData"
                    :options="practiceTypes"
                    :isDisabled="isDisabled || isPracticeTypeDisabled"
                    valuePath="practiceType"
                    @change="change($event)"
                ></radio-field>
            </form-cell>
        </form-row>

        <form-row v-if="formData.practiceType">
            <form-cell>
                <suggest-field
                    v-if="isPracticeSuggestable"
                    :class="{ 'form-input-text--is-invalid': highlightMissingFields && !formData.practiceName }"
                    :label="labelName"
                    :placeholder="placeholderName"
                    :suggestionsCall="practiceSuggestionsCall"
                    :isRequired="true"
                    :isSuggested="isSuggested"
                    :isDisabled="isDisabled"
                    :formData="formData"
                    valuePath="practiceName"
                    @change="change($event)"
                    @select="updatePracticeData($event)"
                ></suggest-field>
                <text-field
                    v-else
                    :class="{ 'form-input-text--is-invalid': highlightMissingFields && !formData.name }"
                    :label="labelName"
                    :placeholder="placeholderName"
                    :isRequired="true"
                    :isDisabled="isDisabled"
                    :formData="formData"
                    valuePath="name"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>
    </div>
</template>

<script>
    import FormFragmentMixin from 'mixins/FormFragmentMixin'
    import FormChangeableMixin from 'mixins/FormChangeableMixin'
    import PracticesAPI from 'api/PracticesAPI'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        mixins: [FormFragmentMixin, FormChangeableMixin],

        props: {
            isPracticeSuggestable: { type: Boolean, default: true },
            isPracticeTypeDisabled: { type: Boolean, default: false },
            highlightMissingFields: { type: Boolean, default: false },
        },

        data() {
            return {
                isSuggested: false,
            }
        },

        computed: {
            practiceTypes() {
                return [PracticeTypeEnum.PHYSICIAN, PracticeTypeEnum.ANCILLARY, PracticeTypeEnum.OTHER].map((value) => ({
                    label: this.$t(`forms.auth.register.fields.practice_type.options.${value}.label`),
                    value,
                    infoTip: this.$t(`forms.auth.register.fields.practice_type.options.${value}.toolTip`),
                }))
            },

            labelName() {
                return this.formData.practiceType === PracticeTypeEnum.PHYSICIAN
                    ? this.$t('forms.auth.register.fields.practice_name.label')
                    : this.$t('forms.auth.register.fields.ancillary_name.label')
            },

            placeholderName() {
                return this.formData.practiceType === PracticeTypeEnum.PHYSICIAN
                    ? this.$t('forms.auth.register.fields.practice_name.placeholder')
                    : this.$t('forms.auth.register.fields.ancillary_name.placeholder')
            },

            practiceSuggestionsCall() {
                return (query) => PracticesAPI.getList(query, this.formData.practiceType)
            },
        },

        methods: {
            updatePracticeData({ data } = {}) {
                this.change({
                    path: 'practiceId',
                    value: this.$get(data, 'id'),
                })
                this.change({
                    path: 'practiceType',
                    value: this.$get(data, 'practiceType') || this.formData.practiceType,
                })

                this.change({
                    path: 'selectedPracticeName',
                    value: this.$get(data, 'name'),
                })

                this.isSuggested = Boolean(data)
            },
        },

        mounted() {
            this.$on('local:beforeChange:practiceType', ({ value: practiceType }) => {
                if (typeof this.formData.practiceType === 'undefined') {
                    return
                }

                if (practiceType === this.formData.practiceType) {
                    return
                }

                if (this.isPracticeSuggestable) {
                    this.change({ path: 'practiceName', value: '' })
                    this.change({ path: 'practiceId', value: '' })
                }
            })

            this.$on('local:beforeChange:practiceName', () => {
                this.isSuggested = false
            })
        },
    }
</script>
